
import Vue from 'vue';
import Component from "vue-class-component";
import {Prop} from "vue-property-decorator";
import {RejectionDetailsModel} from "@/api-client";

@Component
export default class RejectionDetails extends Vue {
    @Prop({required: true})
    details!: RejectionDetailsModel;
}
